import parseNavigation from "./navigation-parser.js";
import getNavigationState from "./navigation-state.js";
import initMegaNav from "./mega-nav.js";
import initMobileNav from "./mobile-nav.js";
import initSidebarNav from "./sidebar-nav.js";
import initFooterNav from "./footer-nav.js";
import initCategorySections from "./category-sections.js";

function initHomeLink() {
  console.log("INIT Home Link RUNNING");
  const sourceNav = document.querySelector("#sz-nav-source a");
  const homeLink = document.querySelector("#sz-home-link");

  if (!sourceNav || !homeLink) return;

  const href = sourceNav.getAttribute("href");
  if (!href) return;

  homeLink.setAttribute("href", href);

  if (
    window.location.pathname === new URL(href, window.location.origin).pathname
  ) {
    homeLink.setAttribute("aria-current", "page");
  }
}

export default function initNavigation() {
  console.log("INIT Navigation RUNNING");
  initHomeLink();

  const state = getNavigationState();
  if (!state) return;

  const mq = window.matchMedia("(min-width: 992px)");

  function renderNav() {
  const container = document.querySelector(".sz-main-nav .container");
  const nav = document.querySelector(".sz-main-nav");
  const backdrop = document.querySelector(".sz-nav-backdrop");

  if (!container || !nav) return;

  // ✅ HARD RESET EVERYTHING
  nav.classList.remove("is-open");

  document.body.classList.remove("nav-open");
  document.body.style.overflow = "";

  if (backdrop) backdrop.hidden = true;

  // clear DOM
  container.replaceChildren();

  if (mq.matches) {
    initMegaNav(state);
  } else {
    initMobileNav(state);
  }
}

  // initial render
  renderNav();

  // re-render on breakpoint change
  mq.addEventListener("change", renderNav);

  initSidebarNav();
  initCategorySections();
  initFooterNav(state);
}
